import React from 'react';
import logo from './assets/images/logo-spartacus-black.png';
import './screens/404/404.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  handleReload = () => {
    window.location.reload();
  };

  handleHome = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      const isChunkError = this.state.error &&
        (this.state.error.name === 'ChunkLoadError' ||
         /loading chunk/i.test(this.state.error.message) ||
         /failed to fetch/i.test(this.state.error.message));

      if (isChunkError) {
        window.location.reload();
        return null;
      }

      return (
        <div className="not-found-page">
          <div className="not-found-content">
            <img src={logo} alt="Spartacus" className="not-found-logo" />
            <h1 className="not-found-brand">SPARTACUS</h1>
            <div className="not-found-divider" />
            <div className="not-found-code">
              <span className="not-found-4" style={{ color: '#dc2626' }}>!</span>
            </div>
            <h2 className="not-found-title">Erro inesperado</h2>
            <p className="not-found-description">
              Algo deu errado ao carregar esta pagina. Tente novamente ou volte ao inicio.
            </p>
            <div style={{ display: 'flex', gap: 12 }}>
              <button onClick={this.handleRetry} className="not-found-btn" style={{
                padding: '12px 32px', border: 'none', borderRadius: 12,
                background: '#dbeafe', color: '#1e40af', fontWeight: 600,
                cursor: 'pointer', fontSize: 15,
              }}>
                Tentar novamente
              </button>
              <button onClick={this.handleHome} className="not-found-btn" style={{
                padding: '12px 32px', border: '1px solid #e2e8f0', borderRadius: 12,
                background: '#f8fafc', color: '#475569', fontWeight: 600,
                cursor: 'pointer', fontSize: 15,
              }}>
                Voltar ao inicio
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
